<div class="background-container container">
  <div class="outer-container">
    <ng-container *ngIf="site">
      <div class="status-header-container">
        <div class="site-actions-container">
          <div class="main-buttons">
            <button
              (click)="doOpenSite()"
              class="button-margin-right"
              id="view-map-link"
              color="primary"
              mat-stroked-button>
              View Map
            </button>
          </div>
          <mat-form-field class="field bulk-actions">
            <mat-select (selectionChange)="siteAction($event)" placeholder="Site Actions" data-cy="bulk-action-select">
              <mat-option *ngIf="canChangeStatus" value="status">Change Site Status</mat-option>
              <mat-option *ngIf="!isLimitedAdmin && site.submittedDate !== null" value="eDoc">Send eDoc</mat-option>
              <mat-option *ngIf="!isLimitedAdmin" value="email">Send Email</mat-option>
              <mat-option *ngIf="canPaySites" [disabled]="!allowPayment || !hasStripe" value="pay">Pay Site</mat-option>
              <mat-option *ngIf="canSplitSite()" value="split">Split Site</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="site-detail-heading-container">
          <div class="site-name-row">{{ site.name }}</div>
          <div class="site-status">
            Status:
            <span>{{ site.status }}</span>
          </div>
        </div>
        <mat-divider>&nbsp;</mat-divider>
      </div>
      <div class="inner-container">
        <mat-accordion [togglePosition]="'before'" multi>
          <fc-site-approval-step-1
            (doChangeSiteState)="doChangeSiteState($event)"
            *ngIf="site.activationDate === null && !isLimitedAdmin"
            [expanded]="step1Expanded"
            [isSuperAdmin]="isSuperAdmin"></fc-site-approval-step-1>

          <fc-site-approval-step-2
            (doChangeSiteState)="doChangeSiteState($event)"
            *ngIf="site.activationDate === null && !isLimitedAdmin"
            [expanded]="step2Expanded"
            [isAdmin]="true"
            [site]="site"></fc-site-approval-step-2>

          <fc-site-approval-step-3
            (doChangeSiteState)="doChangeSiteState($event)"
            *ngIf="site.activationDate === null && !isLimitedAdmin"
            [currentUser]="currentUser"
            [expanded]="step3Expanded"
            [isAdmin]="true"
            [site]="site"></fc-site-approval-step-3>

          <fc-site-detail-information
            *ngIf="site.activationDate !== null || site.submittedDate === null || isLimitedAdmin"
            [isAdmin]="isAdmin"
            [isLimitedAdmin]="isLimitedAdmin"
            [isSuperAdmin]="isSuperAdmin"></fc-site-detail-information>

          <fc-site-detail-payments
            [canPaySites]="canPaySites"
            [isLandowner]="!isAdmin && !isLimitedAdmin"
            [isSuperAdmin]="isSuperAdmin"></fc-site-detail-payments>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title data-cy="documents-header">Document Management</mat-panel-title>
            </mat-expansion-panel-header>
            <mat-divider></mat-divider>
            <fc-site-doc-list [activeSite]="site"></fc-site-doc-list>
          </mat-expansion-panel>

          <fc-site-verification-visits
            [isAdmin]="isAdmin"
            [isLimitedAdmin]="isLimitedAdmin"
            [site]="site"></fc-site-verification-visits>

          <fc-site-detail-reports [isAdmin]="isAdmin" [site]="site"></fc-site-detail-reports>

          <fc-site-detail-notes [currentUser]="currentUser" [site]="site"></fc-site-detail-notes>

          <fc-site-status-log [isAdmin]="isAdmin" [site]="site"></fc-site-status-log>
        </mat-accordion>
      </div>
    </ng-container>
  </div>
</div>
